(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/change-bank/change-bank.js') >= 0) return;  svs.modules.push('/components/accountservices-react/deposit/assets/react/swedbank-express/pages/change-bank/change-bank.js');
'use strict';

function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
const Button = svs.ui.ReactButton;
const _svs$ui$reactForm = svs.ui.reactForm,
  Form = _svs$ui$reactForm.Form,
  ControlGroup = _svs$ui$reactForm.ControlGroup,
  Select = _svs$ui$reactForm.Select,
  Option = _svs$ui$reactForm.Option;
const logger = svs.accountservicesReact.deposit.swedbankExpress.logger;
const ChangeBank = _ref => {
  let onClickChangeBank = _ref.onClickChangeBank,
    onClickReturn = _ref.onClickReturn,
    bankList = _ref.bankList,
    isConsentSelectBank = _ref.isConsentSelectBank;
  const _React$useState = React.useState('-1'),
    _React$useState2 = _slicedToArray(_React$useState, 2),
    selectedBankSubsidiaryId = _React$useState2[0],
    setSelectedBankSubsidiaryId = _React$useState2[1];
  const _React$useState3 = React.useState(false),
    _React$useState4 = _slicedToArray(_React$useState3, 2),
    isBankSelected = _React$useState4[0],
    setIsBankSelected = _React$useState4[1];
  React.useEffect(() => {
    if (bankList && bankList.length > 0) {
      const recentBank = bankList.find(b => b.recent === 1);
      if (recentBank && recentBank.bankSubsidiaryId) {
        logger.debug('*** ChangeBank - Found recent Bank, changing dropdow to: ', recentBank);
        setSelectedBankSubsidiaryId(recentBank.bankSubsidiaryId);
        setIsBankSelected(true);
      }
    }
  }, [bankList]);

  const handleOnChangeBank = e => {
    setSelectedBankSubsidiaryId(e.target.value);
    setIsBankSelected(true);
  };
  const handleOnClickChangeBank = () => {
    onClickChangeBank({
      bankSubsidiaryId: selectedBankSubsidiaryId,
      isConsentSelectBank
    });
  };
  const handleOnClickReturn = () => {
    onClickReturn();
  };
  let counter = 0;
  return React.createElement("div", {
    className: "margin-top-2"
  }, React.createElement(Form, {
    method: "post"
  }, React.createElement(ControlGroup, {
    v2: true
  }, React.createElement(Select, {
    id: "bankslist",
    label: "Bank",
    onChange: e => handleOnChangeBank(e),
    v2: true,
    value: selectedBankSubsidiaryId
  }, React.createElement(Option, {
    disabled: true,
    value: "-1"
  }, "V\xE4lj bank"), bankList && bankList.length > 0 && bankList.map(bank => React.createElement(Option, {
    key: bank.bankSubsidiaryId + counter++,
    value: bank.bankSubsidiaryId
  }, bank.bankName)))), React.createElement(Button, {
    block: true,
    className: "margin-top-2",
    disabled: !isBankSelected,
    focus: true,
    onClick: handleOnClickChangeBank
  }, "H\xE4mta bankkonton"), React.createElement(Button, {
    block: true,
    className: "margin-top-1",
    onClick: handleOnClickReturn,
    transparent: true
  }, "Tillbaka")));
};
svs.accountservicesReact.deposit.swedbankExpress.pages.changeBank.ChangeBank = ChangeBank;

 })(window);